import { RoleBasedBotPolicy } from '../../core/role-based-policy';
import type { BotPolicy, BotPolicyContext } from '../../core/types';

export const CLASSIC_BOT_ID = 'classic';
export const CLASSIC_BOT_VERSION = '1.0.0';

export function createClassicBotPolicy(context: BotPolicyContext): BotPolicy {
  return new RoleBasedBotPolicy(CLASSIC_BOT_ID, CLASSIC_BOT_VERSION, context);
}
